import { cn } from "@/utils/utils";
import { PILL_BASE, PILL_DOT, STORY_STATUS_PILL } from "@/components/cms/ui/pill-styles";

interface StatusBadgeProps {
  status: 'draft' | 'live' | 'archived' | 'pending' | 'locked' | 'template';
  className?: string;
}

export function StatusBadge({ status, className }: StatusBadgeProps) {
  const labels = {
    draft: "Draft",
    live: "Live",
    archived: "Archived",
    pending: "Pending",
    locked: "Locked",
    template: "Template"
  };

  return (
    <span className={cn(PILL_BASE, "box-border", STORY_STATUS_PILL[status], className)}>
      <span className={PILL_DOT} />
      {labels[status]}
    </span>
  );
}
